import { computed, ref } from 'vue'
import { useAutoRefresh } from '../useAutorefresh'
import { useEyeStore } from '@/stores/eyeStore'
import type { LimitSide, SymbolLimits } from '@/services/eye-v2-service/types'
import type { MarketType } from '@/utils/types'

export const useCexCexLimitsRefresher = (
  exBuy: string | null,
  exSell: string | null,
  asset: string | null,
  marketType: MarketType | null,
  sellAsset: string | null = null,
  quoteBuy: string = 'USDT',
  quoteSell: string = 'USDT',
) => {
  const eyeStore = useEyeStore()
  const limitsActionId = computed(() => `limits/${exBuy}/${exSell}/${asset}/${sellAsset || 'none'}/${marketType}/${quoteBuy}/${quoteSell}`)

  const limits = ref<Record<LimitSide, SymbolLimits> | null>()
  const limitsLoading = computed(() => eyeStore.loading[limitsActionId.value])

  const updateLimits = async () => {
    if (!exBuy || !exSell || !asset || !marketType) {
      return
    }
    const req = await eyeStore.fetchMarketLimits(
      limitsActionId.value,
      exBuy,
      exSell,
      asset,
      marketType,
      sellAsset,
      quoteBuy,
      quoteSell,
    )
    limits.value = req
  }
  const limitsRefresher = useAutoRefresh(() => updateLimits(), 30000)

  return {
    limitsRefresher,
    updateLimits,
    limits,
    limitsLoading,
  }
}
